import { memo } from 'react'
import { Helmet } from 'react-helmet-async'

interface Props {
  offer: App.HotelOffer | App.VillaOffer
}

function HotelStructuredData(props: Props) {
  const { offer } = props

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Hotel',
    name: offer.property.name,
    description: offer.description,
    address: {
      '@type': 'PostalAddress',
      addressCountry: offer.property.geoData.countryCode,
      addressRegion: offer.property.geoData.administrativeAreaLevel1,
      addressLocality: offer.property.geoData.locality,
      streetAddress: offer.property.address,
    },
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  )
}

export default memo(HotelStructuredData)
